import axios from '@/libs/api.request'
import config from '@/config'

const baseCloudUrl = config.basePrivateCloudUrl
const privateCloudBaseUrl = baseCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudNetworkQuota = (projectId, params) => {
  return axios.request({
    url: `${privateCloudBaseUrl}network_quota/${projectId}/`,
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const updatePrivateCloudNetworkQuota = (data, projectId) => {
  return axios.request({
    url: `${privateCloudBaseUrl}network_quota/${projectId}/`,
    needPrivateCloudProjectHeader: true,
    data: data,
    method: 'put'
  })
}
